const painterService = {
  title: "Painter",
  icon: "🎨",
  shortDescription:
    "Minor paint work, touch-up, putty, patch repair, and wall finishing support.",
  longDescription:
    "Book painting support for touch-up jobs, patch areas, repair finishing, and basic room or wall refresh work. Final pricing varies by area and paint requirement.",
  consultationNote:
    "Large area painting and exact paint estimate may require inspection or measurement.",
  responsePromise:
    "Assignment depends on painting scope, timing, and local availability.",
  warrantyPolicy:
    "Revisit or support depends on paint type, wall condition, and moisture exposure.",
  subServices: [
    {
      id: "painter-wall-touchup",
      title: "Wall Touch-Up",
      icon: "🖌️",
      group: "Touch-Up",
      description:
        "Touch-up paint on small damaged, stained, or uneven wall sections.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "1-2 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "painter-putty-patch",
      title: "Putty / Patch Repair",
      icon: "🧴",
      group: "Wall Repair",
      description:
        "Fill patch area, surface dents, or small damaged wall sections before paint finishing.",
      basePrice: 449,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "painter-door-window-paint",
      title: "Door / Window Paint Touch-Up",
      icon: "🚪",
      group: "Touch-Up",
      description:
        "Minor paint refresh or surface coating support for doors and window frames.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "1-2 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "painter-room-inspection",
      title: "Paint Work Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection visit for room painting, moisture concern, finish quality, or exact estimate.",
      basePrice: 299,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default painterService;